import { Serializable } from '@admin/core/models/serializable';

export class MatchingAnnouncementsFilterModel
  implements Serializable<MatchingAnnouncementsFilterModel>
{
  fromObject(obj: any): MatchingAnnouncementsFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      AnnouncementId: this.announcementId,
      portfolioId: this.portfolioId,
      AnnouncementTitle: this.announcementTitle,
      CompanyName: this.companyName,
      ApprovalStatusId: this.approvalStatusId,
    };
    return result;
  }

  public announcementId: number;
  public portfolioId: number;
  public announcementTitle: string;
  public companyName: string;
  public approvalStatusId: number;

  constructor() {
    this.announcementId = null;
    this.announcementTitle = null;
    this.companyName = null;
    this.approvalStatusId = null;
  }
}
